import { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import { ventrisConfig } from '../ventris.config';

type OrganizationFilterProps = {
    updateFilter: any;
    organizations?: any;
};

function OrganizationFilter({ updateFilter, organizations: providedOrganizations }: OrganizationFilterProps) {
  const [organization, setOrganization] = useState("All" as any);
  const [organizations, setOrganizations] = useState([] as any);
  
  useEffect(() => {
    if (providedOrganizations) {
      setOrganizations(providedOrganizations);
      return;
    }

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/organizations?compact=true', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setOrganizations(data);
    });
  }, [providedOrganizations]);

  return (
    <div className="filters">
        <Container fluid>
            <Row>
                <Col className="filter-wrapper">
                    <Dropdown className="filter-dropdown">
                        <Dropdown.Toggle variant="light" id="dropdown-basic">
                            <span className="filter-value">Organization: {organization}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'scroll' }}>
                            <Dropdown.Item onClick={() => { setOrganization("All"); updateFilter(["All"]); }}>All</Dropdown.Item>
                            {organizations.map((organization: any) =>
                                <Dropdown.Item onClick={() => { setOrganization(organization.name); updateFilter(organization.child_organizations); }}>{organization.name}</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>
        </Container>
    </div>
  );
}

export default OrganizationFilter;
